import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, Close, Input, Search } from 'common-ui-components';
import { selectConfig, selectReferral } from '../../redux/selectors';
import CoverageMap from '../../components/CoverageMap';
import { useDispatch } from 'react-redux';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import {
  INITIAL_ADDRESS,
  setHasAddressCoverage,
  setReferralAddress,
} from '../../redux/Slice/referralSlice';

const ValidateCoverage = () => {
  const {
    language: { validateCoverage: text },
  } = useSelector(selectConfig);
  const dispatch = useDispatch();
  const { address } = useSelector(selectReferral);
  const [openMap, setOpenMap] = React.useState(false);

  const handleMapClick = () => {
    setOpenMap(true);
  };

  const handleClick = () => {
    if (address.address === '') {
      setOpenMap(true);
      return;
    }
    if (!address.hasCoverage) {
      dispatch(navigateTo('NoCoverageError'));
      return;
    }
    dispatch(navigateTo('PersonalData'));
  };

  const setHasCoverage = (value) => dispatch(setHasAddressCoverage(value));

  useEffect(() => {
    dispatch(
      setReferralAddress({
        ...INITIAL_ADDRESS,
        address: address.address,
        hasCoverage: address.hasCoverage,
        isBuilding: address.isBuilding,
      }),
    );
  }, []);

  return (
    <div className='section validateCoverage-container'>
      <header className='validateCoverage-header'>
        <h3 className='validateCoverage'>{text.header}</h3>

        {!openMap && (
          <>
            <p className='validateCoverage-subtitle'>{text.subtitle}</p>
            <div onClick={handleMapClick} className='validateCoverage-input'>
              <Input
                className='validateCoverage-input'
                labelText={text.inputPlaceholder}
                iconPosition='trailing-icon'
                value={address.address}
                readOnly
                compact
              >
                <Search></Search>
              </Input>
            </div>
            <Button
              className='submit-button-error validateCoverage-button'
              onClick={handleClick}
              disabled={address.address === ''}
              data-testid='validateCoverage-continue-button'
            >
              {text.button}
            </Button>
          </>
        )}
        <div className={`validateCoverage-mapContainer${openMap ? '-opened' : ''}`}>
          {openMap && (
            <></>
          )}
          <CoverageMap
            openModal={openMap}
            handleCloseModal={() => setOpenMap(false)}
            setHasCoverage={setHasCoverage}
            setOpenMap={setOpenMap}
          />
        </div>
      </header>
    </div>
  );
};

export default ValidateCoverage;
